import script from "./ContractCardModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ContractCardModal.vue?vue&type=script&setup=true&lang=js"

import "./ContractCardModal.vue?vue&type=style&index=0&id=06235144&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06235144"]])

export default __exports__